import { EventCategory, Event } from '@fluidx/office-fluid-types';
import { LogProcessor, LoggerContext } from './LogProcessor.types';

class ConsoleLogProcessor implements LogProcessor {
  public logEvent(event: Event): void {
    switch (event.category) {
      case EventCategory.Error:
        console.error('%cPurple: %c%s', 'color: purple; font-style: italic', '', JSON.stringify(event));
        break;
      default:
        console.log('%cPurple: %c%s', 'color: purple; font-style: italic', '', JSON.stringify(event));
    }
  }

  public setContext(_context: LoggerContext): void {}

  public shutdown(): void {}
}

export const consoleLogProcessor = new ConsoleLogProcessor();
